module.exports = __webpack_public_path__ + "static/media/as.e0de4550.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/as.svg
// module id = 771
// module chunks = 0